import styled from 'styled-components';
export var StyledCarouselHeadingArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCarouselHeadingArea",
  componentId: "c11n-8-107-0__sc-1uioglg-0"
})([""]);